import PropTypes from 'prop-types';
import React, {Component} from 'react';
import MenuItem from 'material-ui/MenuItem';
import SelectField from 'material-ui/SelectField';
import * as Colors from 'material-ui/styles/colors';
import _ from 'lodash';
import CheckIcon from 'material-ui/svg-icons/navigation/check';
import {stringToDashed} from 'cl-automation-utils';

export const eBaySites = [
  'Argentina',
  'Brazil',
  'Canada',
  'Colombia',
  'Mexico',
  'United States',
  'Austria',
  'Belgium',
  'France',
  'Germany',
  'Ireland',
  'Italy',
  'Netherlands',
  'Spain',
  'Sweden',
  'Switzerland',
  'United Kingdom',
  'Australia',
  'China',
  'Hong Kong',
  'India',
  'Korea',
  'Malaysia',
  'New Zealand',
  'Philippines',
  'Singapore',
  'Taiwan',
].sort();

const LONGEST_SITE_WIDTH = 195;

export default class EbaySitesDropMenu extends Component {
  state = {
    selectedSite: 'United States',
  };

  handleChange = (event, index, selectedSite) => this.setState({selectedSite});

  render() {
    const {selectedSite} = this.state;
    const {id} = this.props;
    return (
      <SelectField
        id={id}
        value={selectedSite}
        onChange={this.handleChange}
        underlineStyle={{bottom: 12}}
        style={{width: LONGEST_SITE_WIDTH, overflow: 'hidden'}}
        floatingLabelText="eBay Site"
        floatingLabelStyle={{color: Colors.green700}}
      >
        {_.map(eBaySites, eBaySite => (
          <MenuItem
            innerDivStyle={{paddingRight: 55, paddingLeft: 10}}
            style={{display: 'flex', flexDirection: 'row', justifyContent: 'flex-start'}}
            id={`cla-menuitem-site-${stringToDashed(eBaySite)}`}
            key={eBaySite}
            value={eBaySite}
            primaryText={eBaySite}
            rightIcon={
              selectedSite === eBaySite ? (
                <CheckIcon style={{fill: Colors.lightGreen700}} />
              ) : (
                <CheckIcon style={{opacity: 0}} />
              )
            }
          />
        ))}
      </SelectField>
    );
  }
}
